module.exports = __webpack_public_path__ + "static/img/agitator.b7f1b8c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/primitives/fvAgitator/img/agitator.gif
// module id = 9W0+
// module chunks = 3